import { render, staticRenderFns } from "./InformationCaption.vue?vue&type=template&id=291db8a2&scoped=true&"
import script from "./InformationCaption.vue?vue&type=script&lang=js&"
export * from "./InformationCaption.vue?vue&type=script&lang=js&"
import style0 from "./InformationCaption.vue?vue&type=style&index=0&id=291db8a2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291db8a2",
  null
  
)

export default component.exports